import styled from "styled-components";
import { FaPlus } from "react-icons/fa";
import { Typography } from "antd";
import { darken, lighten } from "polished";

export const StyledRootNode = styled.div<{ selected: boolean }>`
  border-radius: 15px;
  position: relative;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
  overflow: visible;
  cursor: help;
  background: ${({ theme, selected }) =>
    selected
      ? lighten(0.1, theme.palette.primary.main)
      : lighten(0.2, theme.palette.primary.main)};
  border: 2px solid
    ${({ theme, selected }) =>
      selected
        ? darken(0.2, theme.palette.primary.main)
        : darken(0.2, theme.palette.primary.main)};
  color: ${({ theme }) => theme.palette.black}!important;

  &:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 25px;
    width: 20px;
    height: 20px;
    background: ${({ theme, selected }) =>
      selected
        ? lighten(0.1, theme.palette.primary.main)
        : lighten(0.2, theme.palette.primary.main)};
    transform: rotate(45deg);
    border-right: 2px solid
      ${({ theme, selected }) =>
        selected
          ? darken(0.2, theme.palette.primary.main)
          : darken(0.2, theme.palette.primary.main)};
    border-bottom: 2px solid
      ${({ theme, selected }) =>
        selected
          ? darken(0.2, theme.palette.primary.main)
          : darken(0.2, theme.palette.primary.main)};
  }
`;

export const StyledRootNodeContent = styled.div<{
  selected: boolean;
  width: number;
  height: number;
}>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: help;
  overflow: hidden;

  &:hover {
    .node-actions {
      bottom: 0px;
      right: 5px;
    }
  }
`;

export const StyledNodeTitle = styled(Typography)`
  padding: 5px;
  font-size: 12px;
  color: inherit !important;
`;

export const StyledNodeDetail = styled(Typography.Text)`
  font-size: 18px;
  text-align: center;
  color: inherit !important;
  width: 80%;
`;

export const StyledNodeHover = styled.div`
  transition: all 0.3s ease;
  position: absolute;
  bottom: -20px;
  right: 5px;
  width: 100%;
  height: 20px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const StyledNodeAddButton = styled(FaPlus)`
  cursor: pointer;
  color: inherit !important;
`;
